import { z } from 'zod';
export var OrderItem = z.object({
  orderId: z.string().nullish(),
  cost: z.object({
    currency: z.string(),
    amount: z.number()
  }),
  description: z.string().nullish(),
  name: z.string(),
  orderItemCategory: z.string().nullish(),
  payableType: z.string(),
  credits: z.array(z.object({
    cost: z.object({
      currency: z.string(),
      amount: z.number()
    }).optional()
  })),
  discounts: z.array(z.object({
    cost: z.object({
      currency: z.string(),
      amount: z.number()
    }).optional()
  }))
});
export var OrderItemResponse = z.object({
  id: z.string(),
  type: z.literal('order_item'),
  attributes: z.object({}).passthrough()
});